import Vue from 'vue'
import './plugins/axios'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'

import VueSocketIO from 'vue-socket.io'

import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import i18n from './i18n'

import moment from 'moment-hijri'
Vue.prototype.$moment = moment

import VueYoutube from 'vue-youtube'   
Vue.use(VueYoutube)

require('typeface-aladin')
require('typeface-eczar')

var targetApi = ""
if(process.env.VUE_APP_SERVED == "server"){
    targetApi = { ip: process.env.VUE_APP_LOCAL_SERVER_IP, lineStatus: 'offline' }
} else if (process.env.VUE_APP_SERVED == "client"){    
    targetApi = { ip: process.env.VUE_APP_REMOTE_SERVER_IP, lineStatus: 'offline' }
} else if (process.env.VUE_APP_SERVED == "online"){    
    targetApi = { ip: process.env.VUE_APP_EXTERNAL_SERVER_IP, lineStatus: 'online' }
}

localStorage.setItem('api', targetApi.ip)
localStorage.setItem('lineStatus', targetApi.lineStatus)
store.commit('server', targetApi.ip)

Vue.use(new VueSocketIO({
    debug: false,
    connection: targetApi.ip,
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    }
}))

Vue.config.productionTip = false


new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

// document.addEventListener('deviceReady', () => {
//   console.log('metal')
// }, false)

    // onDeviceReady: function () {
    //   // Handle the device ready event.
    //   this.cordova.on('pause', this.onPause, false)
    //   this.cordova.on('resume', this.onResume, false)
    //   if (this.cordova.device.platform === 'Android') {
    //     document.addEventListener('backbutton', this.onBackKeyDown, false)
    //   }
    //   this.cordova.plugins.autoStart.enable();
    //   this.cordova.plugins.insomnia.keepAwake();
    // },

    // onPause () {
    //   // Handle the pause lifecycle event.
    //   console.log('pause')
    // },

    // onResume () {
    //   // Handle the resume lifecycle event.
    //   // SetTimeout required for iOS.
    //   setTimeout(function () {
    //   console.log('resume')
    //   }, 0)
    // },
    
    // onBackKeyDown () {
    //   // Handle the back-button event on Android. By default it will exit the app.
    //   navigator.app.exitApp()
    // }    